import { Injectable } from '@angular/core';
import { ResponseData, PaginatorResponse } from '@klickdata/core/http';
import { PostService, Post, PostData } from '@klickdata/core/post';
import { TableHttpService, TableSource, TableHttpHelpers } from '@klickdata/core/table';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class PostListService extends PostService implements TableHttpService<Post> {
    public fetchData(source: TableSource<Post>): Observable<ResponseData<Post[]>> {
        const req = this.builder.get<PostData[]>(this.resourceUrl);
        req.putEager('tags');
        TableHttpHelpers.managePagination(source.paginator, req);
        TableHttpHelpers.manageSort(source.sort, req);
        TableHttpHelpers.mapFilter(source.filter, req);

        return req.request().pipe(
            map((res: PaginatorResponse<PostData[]>) => {
                return {
                    data: res.data.map((item) => {
                        return this.createPost(item);
                    }),
                    notify: res.notify,
                    paginator: res.paginator,
                };
            })
        );
    }
}
